import { RowFareDto } from "@/dtos";
import { Fare } from "@/entities";

export const formatRowFareDto = (fares: Fare[]): RowFareDto[] => {
    return fares.map(x => {
        const row: RowFareDto = {
            ...x,
            value_label: (x.value / 100).toFixed(2),
            company: x.details.company,
            system_label: x.system?.name ?? '',
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}